import { useEffect, useState } from "react";
import { motion, AnimatePresence, animate } from "framer-motion";

export const Preloader = ({ onComplete }) => {
  const [count, setCount] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const reduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduced) {
      setGone(true);
      onComplete?.();
      return;
    }

    // Deliberate floor so a fast load still reads as a designed beat,
    // not a black flash. Reduced-motion visitors skip above.
    const controls = animate(0, 100, {
      duration: 1.75,
      ease: [0.45, 0.05, 0.25, 1],
      onUpdate: (v) => setCount(Math.round(v)),
      onComplete: () => {
        setGone(true);
        onComplete?.();
      },
    });
    return () => controls.stop();
  }, [onComplete]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.65, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[120] bg-ink flex flex-col justify-between p-6 md:p-10"
          data-testid="preloader"
        >
          <div className="flex items-start justify-between">
            <img src="/logo-white.png" alt="GTM Consultancy" className="h-10 md:h-12 w-auto" />
          </div>

          <div className="overflow-hidden">
            <div
              className="h-px w-full bg-cobalt origin-left mb-4"
              style={{ transform: `scaleX(${count / 100})` }}
            />
            <div className="flex items-end justify-end pr-1">
              <span className="font-display font-semibold text-paper text-[15vw] md:text-[9vw] leading-[0.8] tracking-tight tabular-nums">
                {count}
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
